export const EVENT = 'inscribe-modal'
export const UPLOAD_FILE = 0
export const TEXT_INSCRIBE = 0.5
export const SEND_PAYMENT = 1
export const PAYMENT_RECEIVED = 2
export const INSCRIBE_SUCCESSFUL = 4

export type InscribeContentType = 'BRC20' | 'files' | undefined
export type InscribeFileObject = { id: number; file: File }

export type InscribeControllerPayload = {
	event: string
	file: File
	files?: File[]
	contentType?: InscribeContentType
}
